import Image from 'next/image'
import { ConditionName, IChatCardProps } from '../../../../../interfaces'
import { useAppSelector } from '../../../../../redux/hooks'
import { conditions, getRemainingTime } from '../../../../../helpers'
import { shallowEqual } from 'react-redux'
import dynamic from "next/dynamic";

const EmptyProfileIcon = dynamic(() => import("../../icon-components/emptyProfile"));

const ChatCard = ({ message }: IChatCardProps) => {
  const { usersInfoInChat } = useAppSelector(({ chats: { usersInfoInChat } }) => ({ usersInfoInChat }), shallowEqual);

  const user = usersInfoInChat.find((user: any) => user.user_id === message.author)
  return (
    <div>
      <div
        className={`pl-flex pl-items-center pl-gap-1 pl-font-normal ${conditions(ConditionName.isTouchScreen) ? 'pl-text-[11px]' : 'pl-text-[14px]'}`}>
        {user && Object.keys(user.profile).length > 0 && user.profile.avatar_url ?
          <Image src={user.profile.avatar_url} width={24} height={24} alt='user-profile' className='pl-rounded-full' /> : <EmptyProfileIcon />}
        <p
          className='pl-text-main-highLight pl-text-[14px] pl-font-normal'>{user && Object.keys(user.profile).length > 0 ? user.profile.name : 'کاربر ناشناس'} .</p>
        <span className="pl-text-z-secondary-600 dark:pl-text-z-gray-400 pl-text-[9px]">{getRemainingTime(message.created_at)}</span>
      </div>
      <p
        className='pl-text-[13px] pl-font-normal pl-text-z-gray-700 dark:pl-text-secondary-50 pl-break-words'>{message.text}</p>
    </div>
  )
}

export default ChatCard